import Box from "@mui/material/Box";
import Skeleton from "../../../../../CommonComponents/Skeleton";

const SOADashoardSkeleton = () => {
    return (
        <Box
            sx={{ display: "flex", gap: "12px", width: "100%", height: "152px" }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    bgcolor: "white",
                    width: "520px",
                    height: "152px",
                    gap: "16px",
                    borderRadius:"8px",
                    padding: "16px 20px 16px 20px",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        width: "480px",
                        height: "64px",
                        justifyContent: "space-between",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: " 4px",
                            height: "64px",
                        }}
                    >
                        <Skeleton sx={{ width: "342px", height: "20px", animation: "wave" }} />
                        <Skeleton sx={{ width: "150px", height: "20px", animation: "wave" }} />
                    </Box>
                    <Skeleton sx={{ width: " 90px", height: "36px" }} animation="wave" />
                </Box>

                <Box sx={{display:"flex",justifyContent:"space-between",width:"480px"}}>
                    <Skeleton animation="wave" sx={{ width: "200px", height: "20px"}}/>
                    <Skeleton sx={{ width: "20px", height: "20px"}}/>
                </Box>
                <Skeleton animation="wave" sx={{width: "480px", height: "8px"}}/>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    bgcolor: "white",
                    width: "520px",
                    height: "152px",
                    gap: "16px",
                    borderRadius:"8px",
                    padding: "16px 20px 16px 20px",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        width: "480px",
                        height: "64px",
                        justifyContent: "space-between",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: " 4px",
                            height: "64px",
                        }}
                    >
                        <Skeleton sx={{ width: "342px", height: "20px", animation: "wave" }} />
                        <Skeleton sx={{ width: "150px", height: "20px", animation: "wave" }} />
                    </Box>
                    <Skeleton sx={{ width: " 90px", height: "36px" }} animation="wave" />
                </Box>

                <Box sx={{display:"flex",justifyContent:"space-between",width:"480px"}}>
                    <Skeleton animation="wave" sx={{ width: "200px", height: "20px"}}/>
                    <Skeleton sx={{ width: "20px", height: "20px"}}/>
                </Box>
                <Skeleton animation="wave" sx={{width: "480px", height: "8px"}}/>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    flexDirection:"column",
                    bgcolor: "white",
                    width: "100%",
                    height: "152px",
                    borderRadius:"8px",
                    padding: "16px 20px 16px 20px",
                    gap:"35px"
                }}
            >
                <Box sx={{
                    display: "flex",
                    flexDirection:"column",
                    bgcolor: "white",
                    width: "100%",
                    gap:"5px",
                }}>
                    <Skeleton animation="wave" sx={{ width: "100%", height: "20px"}}/>
                    <Skeleton animation="wave" sx={{ width: "100%", height: "20px"}}/>
                </Box>
                <Box sx={{
                    display: "flex",
                    flexDirection:"column",
                    bgcolor: "white",
                    width: "100%",
                    gap:"15px",
                }}>
                    <Skeleton animation="wave" sx={{ width: "100%", height: "20px"}}/>
                    <Skeleton animation="wave" sx={{ width: "100%", height: "4px"}}/>
                </Box>
            </Box>
        </Box>
    );
};

export default SOADashoardSkeleton;
